// Constants extracted from OrganizationResourcesModule.js

// Constants
export const NAME = "organizationResource";
export const UPDATE_FILTERS = "UPDATE_REPORT_FILTERS" + " " + NAME;
export const INIT_FILTERS = "INIT_REPORT_FILTERS" + " " + NAME;
